import { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { InAppTemplate } from "../../../shared/templates/inapp";

// import { TableComponent } from "../../../shared/components/table";

import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
// import { getDateFromISO, formatPhoneNumber } from "../../../shared/utils";

import { AlertMsg } from "../../../shared/components/alert-msg";

import { LoadingItem } from "../../../shared/components/loading";
// import DownloadIco from "../../../assets/download.svg";
import BackIco from "../../../assets/back.svg";
// import SuspendIco from "../../../assets/icons/suspend.svg";
import EditIco from "../../../assets/icons/edit-green.svg";
// import ShopIco from "../../../assets/shop_ico.svg";
import UploadIco from "../../../assets/icons/store-edit-tilde.svg";

// import ImageIco from "../../../assets/icons/image.svg";

import { appActions } from "../../../redux/actions/in-app";
import { appConstants } from "../../../redux/action-constants/inapp.constants";

import { history } from "../../../shared/_helpers/history";
// import { Editor } from "react-draft-wysiwyg";
import { NavLink } from "react-router-dom";
// import { useFormikContext } from "formik";

// import TrendUp from "../../../assets/trend_up.svg";
// import { useWindowSize } from "../../../hooks/useWindowSize";

import "../store.scss";
// import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "../../../scss/react-draft-wysiwyg.css";

import { MultiSelect } from "react-multi-select-component";
import { Modal, Button } from "react-bootstrap";
import GooglePlacesAutocomplete, {
  geocodeByPlaceId,
  getLatLng,
} from "react-google-places-autocomplete";

const getStoreDetails = async ({ pageProps, payload }: any) => {
  await pageProps.getStoreDetailsAction(payload);
};
const updateStore = async ({ pageProps, payload }: any) => {
  await pageProps.updateStoreAction(payload);
};

const uploadImage = async (
  actionPayload: any,
  otherNames: any,
  pageProps: any,
  uploadId: any
) => {
  return await pageProps.uploadImageAction(actionPayload, otherNames, uploadId);
};

const StoreManagementForm = ({
  StoreData,
  UpdateStore,
  UploadImage,
  storeLogo,
  setStoreLogo,
  storeLogoNew,
  setStoreLogoNew,
  pageProps,
}: any) => {
  const validationSchema = Yup.object({
    name: Yup.string()
      .required("Store name is required")
      .min(2, "Store name must be at least 2 characters"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    phoneNumber: Yup.string()
      .required("Phone number is required")
      .matches(/^[\d\s\-+\\(\\)]+$/, "Invalid phone number format"),
    tags: Yup.array().min(1, "At least one category is required"),
    pricingPolicy: Yup.string().nullable(),
    // .min(0, "Pricing policy must be at least 10 characters"),
    returnPolicy: Yup.string().nullable(),
    // .required("Return policy is required")
    // .min(0, "Return policy must be at least 10 characters"),
    description: Yup.string().nullable(),
    // .required("Store description is required")
    // .min(0, "Store description must be at least 20 characters"),
    streetAddress: Yup.string().required("Address is required"),
    suiteNumber: Yup.string().nullable(),
  });
  const alltags = [
    { label: "African", value: "African" },
    { label: "Indian", value: "Indian" },
    { label: "Middle-Eastern", value: "Middle-Eastern" },
    { label: "Chinese", value: "Chinese" },
    // { label: "Greek", value: "greek" },
  ];
  // console.log("StoreData", StoreData);
  const initialData = StoreData;

  const [showModal, setShowModal] = useState(false);
  const [modalAction, setModalAction] = useState<"update" | "reset" | null>(
    null
  );
  const [addressSearched, setAddressSearched] = useState<any>(null);
  const [addressInputText, setAddressInputText] = useState<string>("");
  const [tags, SetTags] = useState<any>([]);
  const latestUploadIdRef = useRef<any | null>(null);
  // const { getFieldMeta } = useFormikContext<any>();

  const [editorState, setEditorState] = useState(() => {
    if (initialData.description) {
      const blocksFromHTML = htmlToDraft(initialData.description);
      const { contentBlocks, entityMap } = blocksFromHTML;
      const contentState = ContentState.createFromBlockArray(
        contentBlocks,
        entityMap
      );
      return EditorState.createWithContent(contentState);
    }
    return EditorState.createEmpty();
  });

  useEffect(() => {
    if (initialData.description) {
      const blocksFromHTML = htmlToDraft(initialData.description);
      const { contentBlocks, entityMap } = blocksFromHTML;
      const contentState = ContentState.createFromBlockArray(
        contentBlocks,
        entityMap
      );
      setEditorState(EditorState.createWithContent(contentState));
    } else {
      setEditorState(EditorState.createEmpty());
    }
  }, [initialData.description]);

  const parseAddressFields = (address: any) => {
    if (!address?.streetAddress) {
      return {
        streetAddress: address?.streetAddress || "",
        suiteNumber: address?.suiteNumber || "",
      };
    }

    const streetAddress = address.streetAddress;

    // Check if streetAddress contains a suite number pattern (number-address)
    const suiteMatch = streetAddress.match(/^(\d+[A-Za-z]?)-(.+)$/);

    if (suiteMatch) {
      return {
        streetAddress: suiteMatch[2], // The part after the dash
        suiteNumber: suiteMatch[1], // The part before the dash
      };
    }

    // If no suite number pattern found, use as-is
    return {
      streetAddress: streetAddress,
      suiteNumber: address?.suiteNumber || "",
    };
  };

  // Then modify formikInitialValues
  const parsedAddress = parseAddressFields(initialData.address);

  const formikInitialValues = {
    ...initialData,
    tags: Array.isArray(initialData.tags) ? initialData.tags : [],
    pricingPolicyEditable: false,
    returnPolicyEditable: false,
    DescriptionEditable: false,
    description: initialData.description || "",
    country: initialData.address?.country || "",
    province: initialData.address?.province || "",
    city: initialData.address?.city || "",
    postalCode: initialData.address?.postalCode || "",
    streetAddress: parsedAddress.streetAddress || "",
    suiteNumber: parsedAddress.suiteNumber || "",
    address: initialData.address || {},
  };

  useEffect(() => {
    let catFormated: any[] = formikInitialValues.tags.map((each: any) => {
      return { label: each, value: each };
    });
    SetTags(catFormated);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLogoUpload = (e: any) => {
    e.preventDefault();

    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith("image/")) {
      console.error("Please select an image file");
      return;
    }

    // Validate file size (e.g., max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      console.error("File size must be less than 5MB");
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      setStoreLogo({
        file,
        image: reader.result as string,
        timestamp: Date.now(),
      });
      setStoreLogoNew(true);
    };

    reader.onerror = () => {
      console.error("Error reading file");
    };

    // reset file input so next selection always fires
    e.target.value = "";

    reader.readAsDataURL(file);
  };

  const daysOfWeek: string[] = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const formatHour = (hour: number): string => {
    const period = hour >= 12 ? "PM" : "AM";
    const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
    return `${displayHour}:00 ${period}`;
  };

  const parseHour = (timeString: string): number => {
    const [time, period] = timeString.split(" ");
    let hour = parseInt(time.split(":")[0]);
    if (period === "PM" && hour !== 12) hour += 12;
    if (period === "AM" && hour === 12) hour = 0;
    return hour;
  };

  const handleHoursChange = (
    day: string,
    field: string,
    value: any,
    formValues: any,
    setFieldValue: any
  ) => {
    let updatedTimes =
      formValues.availableTimes === null ? [] : [...formValues.availableTimes];
    const dayIndex = updatedTimes.findIndex((item: any) => item.day === day);

    if (field === "enabled") {
      if (value && dayIndex === -1) {
        updatedTimes.push({
          day,
          timeRanges: [{ from: 9, to: 17 }],
        });
      } else if (!value && dayIndex !== -1) {
        updatedTimes.splice(dayIndex, 1);
      }
    } else if (dayIndex !== -1) {
      const parsedValue = parseHour(value);
      updatedTimes[dayIndex].timeRanges[0][field as keyof any] = parsedValue;
    }

    setFieldValue("availableTimes", updatedTimes);
  };

  const isDayEnabled = (day: string, availableTimes: any): boolean => {
    return (
      availableTimes !== null &&
      availableTimes.some((item: { day: string }) => item.day === day)
    );
  };

  const getDayHours = (day: string, availableTimes: any): any => {
    const dayData =
      availableTimes === null
        ? null
        : availableTimes.find((item: { day: string }) => item.day === day);
    return dayData ? dayData.timeRanges[0] : { from: 9, to: 17 };
  };

  const handleSubmit = async (
    values: any,
    { setSubmitting, resetForm }: any
  ) => {
    try {
      let uploadedLogoUrl = values.logoUrl;

      // Use the file from ref
      // console.log("storeLogoNew:", storeLogoNew);

      if (storeLogoNew && storeLogo?.file) {
        // console.log("✅ Uploading file:", storeLogo.file.name);

        const formData = new FormData();
        formData.append("ImageFile", storeLogo.file);

        const uploadId = storeLogo.timestamp;

        latestUploadIdRef.current = uploadId;
        const uploadResponse = await UploadImage(
          formData,
          "",
          pageProps,
          uploadId as string
        );

        // console.log("Upload response:", uploadResponse);

        if (uploadResponse?.fileURL) {
          uploadedLogoUrl = uploadResponse.fileURL;
          // console.log("Image uploaded successfully:", uploadedLogoUrl);
        } else {
          console.error("No file URL in upload response");
        }
      } else {
        console.log("❌ Upload skipped");
      }

      const payloadStreetAddress = values.suiteNumber
        ? `${values.suiteNumber}-${values.streetAddress}`
        : values.streetAddress;

      await UpdateStore({
        pageProps,
        payload: {
          storeId: values.id,
          name: values.name,
          url: values.url,
          logoUrl: uploadedLogoUrl,
          email: values.email,
          phoneNumber: values.phoneNumber,
          tags: tags.map((category: any) => category.value),
          hasSameDayDelivery: values.hasSameDayDelivery,
          availableTimes:
            values.availableTimes === null
              ? null
              : values.availableTimes.map((time: { timeRanges: any[] }) => ({
                  ...time,
                  timeRanges: time.timeRanges.map((range: any) => ({
                    from: range.from,
                    to: range.to,
                  })),
                })),
          address: {
            country: values.country,
            province: values.province,
            city: values.city,
            postalCode: values.postalCode,
            streetAddress: payloadStreetAddress,
            latitude:
              values.address?.lat || initialData?.address?.latitude || "",
            longitude:
              values.address?.lng || initialData?.address?.longitude || "",
            suiteNumber: values.suiteNumber,
          },
          pricingPolicy: values.pricingPolicy,
          returnPolicy: values.returnPolicy,
          description: values.description,
        },
      });

      // Fetch updated store details
      await getStoreDetails({
        pageProps,
        payload: `?Id=${values.id}`,
      });

      // Reset the new logo flag since we've successfully uploaded
      setStoreLogoNew(false);
      setStoreLogo(null);

      // const fileInput = document.getElementById(
      //   "vendor-logo"
      // ) as HTMLInputElement;
      // if (fileInput) {
      //   fileInput.value = "";
      // }

      // Optionally reset the form with updated data
      const updatedStoreDetails =
        pageProps.getStoreDetailsRequest?.request_data?.response?.data || {};
      resetForm({ values: { ...updatedStoreDetails } });

      // console.log("Store updated successfully");
    } catch (error) {
      console.error("Submit error:", error);
    }
  };

  const hourOptions = Array.from({ length: 24 }, (_, i) => (
    <option key={i} value={formatHour(i)}>
      {formatHour(i)}
    </option>
  ));

  const buildFullAddress = (addr: any) =>
    [
      // addr?.streetAddress,
      addr?.suiteNumber
        ? `${addr.suiteNumber}-${addr.streetAddress}`
        : addr?.streetAddress,

      addr?.city,
      addr?.province,
      addr?.postalCode,
      addr?.country,
    ]
      .filter(Boolean)
      .join(", ");

  const handleSelectedAddress = async (
    selection: {
      label: string;
      value: { place_id: string };
    },
    setFieldValue: (field: string, value: any) => void,
    values: any
  ) => {
    try {
      setAddressSearched(selection);
      if (!selection) {
        setFieldValue("streetAddress", "");
        setFieldValue("city", "");
        setFieldValue("province", "");
        setFieldValue("country", "");
        setFieldValue("postalCode", "");
        setFieldValue("address", {});
        return;
      }
      if ((selection as any)?.value?.manual) {
        return;
      }

      const [place] = await geocodeByPlaceId(selection?.value.place_id);
      const components = place?.address_components || [];

      let streetNumber = "";
      let routeName = "";
      let locality = "";
      let adminLevel2 = "";
      let adminLevel1Long = "";
      let countryLong = "";
      let postalCode = "";

      for (const comp of components) {
        if (comp.types.includes("street_number")) streetNumber = comp.long_name;
        if (!streetNumber && comp.types.includes("premise"))
          streetNumber = comp.long_name;
        if (comp.types.includes("route")) routeName = comp.long_name;
        if (comp.types.includes("locality")) locality = comp.long_name;
        if (comp.types.includes("administrative_area_level_2"))
          adminLevel2 = comp.long_name;
        if (comp.types.includes("administrative_area_level_1"))
          adminLevel1Long = comp.long_name;
        if (comp.types.includes("country")) countryLong = comp.long_name;
        if (comp.types.includes("postal_code")) postalCode = comp.long_name;
      }

      let streetAddress = [streetNumber, routeName].filter(Boolean).join(" ");
      if (!streetAddress || !/^\d/.test(streetAddress)) {
        const formatted = (place as any)?.formatted_address as
          | string
          | undefined;
        if (formatted) {
          const firstSegment = formatted.split(",")[0]?.trim();
          if (firstSegment) streetAddress = firstSegment;
        }
      }
      const city = locality || adminLevel2;

      // ✅ Save current unit number before overwriting address
      const currentUnit =
        values?.suiteNumber || values?.address?.suiteNumber || "";

      setFieldValue("streetAddress", streetAddress);
      setFieldValue("city", city);
      setFieldValue("province", adminLevel1Long);
      setFieldValue("country", countryLong);
      setFieldValue("postalCode", postalCode);

      try {
        const { lat, lng } = await getLatLng(place);
        setFieldValue("address", {
          ...((initialData && initialData.address) || {}),
          streetAddress,
          city,
          province: adminLevel1Long,
          country: countryLong,
          postalCode,
          lat:
            lat || values?.address?.lat || initialData?.address?.latitude || "",
          lng:
            lng ||
            values?.address?.lng ||
            initialData?.address?.longitude ||
            "",
          suiteNumber: currentUnit,
        });
      } catch (_) {
        setFieldValue("address", {
          ...((initialData && initialData.address) || {}),
          streetAddress,
          city,
          province: adminLevel1Long,
          country: countryLong,
          postalCode,
          suiteNumber: currentUnit,
          lat: values?.address?.lat || initialData?.address?.latitude || "",
          lng: values?.address?.lng || initialData?.address?.longitude || "",
        });
      }
    } catch (err) {
      // noop
    }
  };

  const geocodeFreeTextIfNeeded = async (
    currentValues: any,
    setFieldValue: (field: string, value: any) => void
  ) => {
    const hasChosenSuggestion = !!addressSearched;
    const typedLooksLikeAddress = /^\d+\s+/.test(addressInputText || "");
    const formikMissingNumber = !/^\d+\s+/.test(
      currentValues?.streetAddress || ""
    );

    if (!hasChosenSuggestion && typedLooksLikeAddress && formikMissingNumber) {
      try {
        const results = await (
          await import("react-google-places-autocomplete")
        ).geocodeByAddress(addressInputText);
        if (results && results[0]) {
          const place: any = results[0];
          const components = place?.address_components || [];

          let streetNumber = "";
          let routeName = "";
          let locality = "";
          let adminLevel2 = "";
          let adminLevel1Long = "";
          let countryLong = "";
          let postalCode = "";

          for (const comp of components) {
            if (comp.types.includes("street_number"))
              streetNumber = comp.long_name;
            if (!streetNumber && comp.types.includes("premise"))
              streetNumber = comp.long_name;
            if (comp.types.includes("route")) routeName = comp.long_name;
            if (comp.types.includes("locality")) locality = comp.long_name;
            if (comp.types.includes("administrative_area_level_2"))
              adminLevel2 = comp.long_name;
            if (comp.types.includes("administrative_area_level_1"))
              adminLevel1Long = comp.long_name;
            if (comp.types.includes("country")) countryLong = comp.long_name;
            if (comp.types.includes("postal_code")) postalCode = comp.long_name;
          }

          let streetAddress = [streetNumber, routeName]
            .filter(Boolean)
            .join(" ");
          if (!/^\d+\s+/.test(streetAddress)) {
            const formattedFirst = (place?.formatted_address || "")
              .split(",")[0]
              ?.trim();
            if (formattedFirst) streetAddress = formattedFirst;
          }
          const city = locality || adminLevel2;

          setFieldValue("streetAddress", streetAddress);
          setFieldValue("city", city);
          setFieldValue("province", adminLevel1Long);
          setFieldValue("country", countryLong);
          setFieldValue("postalCode", postalCode);

          try {
            const { lat, lng } = await getLatLng(place);
            setFieldValue("address", {
              ...((initialData && initialData.address) || {}),
              streetAddress,
              city,
              province: adminLevel1Long,
              country: countryLong,
              postalCode,
              lat:
                lat ||
                currentValues?.address?.lat ||
                initialData?.address?.latitude ||
                "",
              lng:
                lng ||
                currentValues?.address?.lng ||
                initialData?.address?.longitude ||
                "",
              suiteNumber: currentValues?.suiteNumber || "",
            });
          } catch (_) {
            setFieldValue("address", {
              ...((initialData && initialData.address) || {}),
              streetAddress,
              city,
              province: adminLevel1Long,
              country: countryLong,
              postalCode,
              lat:
                currentValues?.address?.lat ||
                initialData?.address?.latitude ||
                "",
              lng:
                currentValues?.address?.lng ||
                initialData?.address?.longitude ||
                "",
              suiteNumber: currentValues?.suiteNumber || "",
            });
          }
        }
      } catch (_) {
        // ignore fallback failure
      }
    }
  };

  return (
    <div className="store-edit-container">
      <div className="store-edit-wrapper">
        <div className="store-edit-content">
          <Formik
            initialValues={formikInitialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            {({
              values,
              setFieldValue,
              isSubmitting,
              resetForm,
              errors,
              touched,
            }) => (
              <Form>
                {/* Store Information Section */}
                <div className="store-edit-top">
                  <div className="inline-section">
                    <div className="store-sub-left">
                      <div className="store-edit-header">
                        <h1 className="store-edit-title">Store information</h1>
                        <p className="store-edit-subtitle">
                          Local information about your store
                        </p>
                        <p className="store-edit-help-text">
                          To make changes to your store's location, please
                          contact our support team{" "}
                          <span className="link">here</span>
                        </p>
                      </div>
                    </div>
                    <div className="store-sub-right">
                      {/* Store Logo and Name Section */}
                      <div className="store-edit-section">
                        <div className="store-edit-grid">
                          {/* Logo Upload */}
                          <div className="store_logo">
                            <div className="store-logo-image">
                              <div className="store_icon">
                                <img
                                  src={storeLogo?.image || StoreData?.logoUrl}
                                  alt=""
                                />
                              </div>
                              <div className="logo_label_wrap">
                                <div className="label_head">Store Logo</div>
                                <label htmlFor="vendor-logo">
                                  <img src={UploadIco} alt="" />
                                  {StoreData?.logoUrl
                                    ? "Upload new logo"
                                    : "Upload logo"}
                                </label>
                              </div>
                              <input
                                accept="image/*"
                                onChange={handleLogoUpload}
                                type="file"
                                name=""
                                id="vendor-logo"
                              />
                            </div>
                            <Button
                              type="button"
                              className="store-edit-submit-button"
                              onClick={() => {
                                setModalAction("update");
                                setShowModal(true);
                              }}
                            >
                              Update Store
                            </Button>
                          </div>

                          {/* Store Name */}
                          <div className="store-edit-form-group">
                            <label className="store-edit-label">
                              Store name
                            </label>
                            <Field
                              className={`store-edit-input ${
                                errors.name && touched.name ? "error" : ""
                              }`}
                              type="text"
                              name="name"
                            />
                            <ErrorMessage
                              name="name"
                              component="div"
                              className="error-message"
                            />
                            <div className="url-preview">{values.url}</div>
                          </div>

                          {/* Store Category */}
                          <div className="store-edit-form-group">
                            <label className="store-edit-label">
                              Store category
                            </label>
                            <MultiSelect
                              options={alltags}
                              value={tags}
                              onChange={SetTags}
                              labelledBy="Select"
                              hasSelectAll={false}
                              className="cat-select-wrap status"
                              valueRenderer={(selected) => {
                                if (selected.length === 0)
                                  return "Select category";

                                const visible = selected.slice(0, 7);
                                const extraCount =
                                  selected.length - visible.length;

                                return (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "5px",
                                    }}
                                  >
                                    {visible.map((s) => (
                                      <span
                                        key={s.value}
                                        style={{
                                          background: "#e5f6f0",
                                          color: "#00C48C",
                                          padding: "2px 8px",
                                          borderRadius: "12px",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {s.label}
                                      </span>
                                    ))}
                                    {extraCount > 0 && (
                                      <span
                                        style={{
                                          background: "#f0f0f0",
                                          color: "#555",
                                          padding: "2px 8px",
                                          borderRadius: "12px",
                                          fontSize: "12px",
                                        }}
                                      >
                                        +{extraCount} more
                                      </span>
                                    )}
                                  </div>
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Contact Information */}
                      <div className="store-edit-section">
                        <div className="store-edit-grid">
                          <div className="store-edit-form-group">
                            <label className="store-edit-label">
                              Store phone number
                            </label>
                            <Field
                              className={`store-edit-input ${
                                errors.phoneNumber && touched.phoneNumber
                                  ? "error"
                                  : ""
                              }`}
                              type="tel"
                              name="phoneNumber"
                            />
                            <ErrorMessage
                              name="phoneNumber"
                              component="div"
                              className="error-message"
                            />
                          </div>

                          <div className="store-edit-form-group">
                            <label className="store-edit-label">
                              Store email address
                            </label>
                            <Field
                              className={`store-edit-input ${
                                errors.email && touched.email ? "error" : ""
                              }`}
                              type="email"
                              name="email"
                            />
                            <ErrorMessage
                              name="email"
                              component="div"
                              className="error-message"
                            />
                          </div>

                          <div className="store-edit-form-group">
                            <label className="store-edit-label">
                              Store address
                            </label>
                            <div
                              className={`dropdown-container ${
                                addressInputText ? "has-content" : ""
                              } ${
                                addressInputText && !addressSearched
                                  ? "typing"
                                  : ""
                              }`}
                            >
                              <GooglePlacesAutocomplete
                                selectProps={{
                                  // value:
                                  //   addressSearched ||
                                  //   (values.streetAddress
                                  //     ? {
                                  //         label: buildFullAddress(values),
                                  //         value: { manual: true },
                                  //       }
                                  //     : null),
                                  value: {
                                    label: buildFullAddress(values),
                                    value: { manual: true },
                                  },
                                  onChange: (val: any) =>
                                    handleSelectedAddress(
                                      val,
                                      setFieldValue,
                                      values
                                    ),
                                  className: "dropdown-content",
                                  classNamePrefix: "address-select", // 🔹 important
                                  placeholder: "Search address",
                                  isClearable: true,
                                  onInputChange: (val: string) =>
                                    setAddressInputText(val || ""),
                                }}
                                autocompletionRequest={{
                                  componentRestrictions: {
                                    country: ["ca"],
                                  },
                                  types: ["address"],
                                }}
                                apiKey={appConstants.GOOGLE_MAP_KEY}
                                debounce={400}
                              />
                            </div>
                            <div className="store-edit-form-group">
                              <label className="store-edit-label">
                                Unit Number
                              </label>
                              <Field
                                className={`store-edit-input ${
                                  errors.suiteNumber && touched.suiteNumber
                                    ? "error"
                                    : ""
                                }`}
                                type="text"
                                name="suiteNumber"
                                placeholder="204"
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  setFieldValue("suiteNumber", e.target.value);
                                  setFieldValue(
                                    "address.suiteNumber",
                                    e.target.value
                                  );
                                }}
                              />
                              <ErrorMessage
                                name="suiteNumber"
                                component="div"
                                className="error-message"
                              />
                            </div>
                            {/* Hidden fields to preserve extracted components */}
                            <input
                              type="hidden"
                              name="streetAddress"
                              value={values.streetAddress}
                            />
                            <input
                              type="hidden"
                              name="city"
                              value={values.city}
                            />
                            <input
                              type="hidden"
                              name="province"
                              value={values.province}
                            />
                            <input
                              type="hidden"
                              name="country"
                              value={values.country}
                            />
                            <input
                              type="hidden"
                              name="postalCode"
                              value={values.postalCode}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Same Day Delivery Toggle */}
                      <div className="store-edit-section">
                        <div className="store-edit-delivery-toggle">
                          <p className="toggle-text">
                            Does{" "}
                            <span className="store-name">
                              {initialData.name}
                            </span>{" "}
                            deliver on the same day as purchase?
                          </p>
                          <label className="toggle">
                            <Field
                              className="store-edit-toggle-input"
                              type="checkbox"
                              name="hasSameDayDelivery"
                            />
                            <span className="slider"></span>
                          </label>
                        </div>
                      </div>

                      {/* Opening Hours */}
                      <div className="store-edit-section">
                        <h3 className="store-edit-section-title opening-hours-title">
                          Opening Hours
                        </h3>
                        <div className="store-edit-hours-section">
                          <div className="store-edit-hours-grid">
                            {daysOfWeek.map((day) => {
                              const isEnabled = isDayEnabled(
                                day,
                                values.availableTimes
                              );
                              const hours = getDayHours(
                                day,
                                values.availableTimes
                              );

                              return (
                                <div key={day} className="store-edit-hours-row">
                                  <div className="store-edit-day-checkbox">
                                    <input
                                      className="store-edit-toggle-input"
                                      type="checkbox"
                                      checked={isEnabled}
                                      onChange={(e) =>
                                        handleHoursChange(
                                          day,
                                          "enabled",
                                          e.target.checked,
                                          values,
                                          setFieldValue
                                        )
                                      }
                                      id={`day-${day}`}
                                    />
                                    <label
                                      className="store-edit-day-label"
                                      htmlFor={`day-${day}`}
                                    >
                                      {day}
                                    </label>
                                  </div>

                                  {isEnabled ? (
                                    <div className="store-edit-time-selectors">
                                      <select
                                        className="store-edit-time-selector"
                                        value={formatHour(hours.from)}
                                        onChange={(e) =>
                                          handleHoursChange(
                                            day,
                                            "from",
                                            e.target.value,
                                            values,
                                            setFieldValue
                                          )
                                        }
                                      >
                                        {hourOptions}
                                      </select>
                                      <span className="store-edit-separator">
                                        -
                                      </span>
                                      <select
                                        className="store-edit-time-selector"
                                        value={formatHour(hours.to)}
                                        onChange={(e) =>
                                          handleHoursChange(
                                            day,
                                            "to",
                                            e.target.value,
                                            values,
                                            setFieldValue
                                          )
                                        }
                                      >
                                        {hourOptions}
                                      </select>
                                    </div>
                                  ) : (
                                    <span className="store-edit-closed-label">
                                      Closed
                                    </span>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="store-edit-section">
                  {/* Store Policies */}
                  <div className="inline-section">
                    <div className="store-sub-left">
                      <h3 className="store-edit-section-title">
                        Store's pricing policy
                      </h3>
                      <p className="store-edit-section-subtitle">
                        Enter your store's dynamic pricing policy here so that
                        users can make more informed decisions while shopping.
                      </p>
                    </div>
                    <div className="store-sub-right">
                      <div className="store-edit-policy-grid">
                        <div className="store-edit-policy-group">
                          <div className="store-edit-policy-label">
                            <div className="store-edit-policy-label-text">
                              Pricing Policy
                            </div>
                            <button
                              className="store-edit-policy-edit-link"
                              type="button"
                              onClick={() =>
                                setFieldValue(
                                  "pricingPolicyEditable",
                                  !values.pricingPolicyEditable
                                )
                              }
                            >
                              {values.pricingPolicyEditable ? (
                                "Done"
                              ) : (
                                <>
                                  <img
                                    className="edit-icon"
                                    src={EditIco}
                                    alt="edit"
                                  />{" "}
                                  Edit
                                </>
                              )}
                            </button>
                          </div>
                          <Field
                            as="textarea"
                            className={`store-edit-policy-content ${
                              errors.pricingPolicy && touched.pricingPolicy
                                ? "error"
                                : ""
                            }`}
                            name="pricingPolicy"
                            readOnly={!values.pricingPolicyEditable}
                          />
                          <ErrorMessage
                            name="pricingPolicy"
                            component="div"
                            className="error-message"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="store-edit-section">
                  {/* Store Return Policies */}
                  <div className="inline-section">
                    <div className="store-sub-left">
                      <h3 className="store-edit-section-title">
                        Store's return policy
                      </h3>
                      <p className="store-edit-section-subtitle">
                        Explain your store's return policy to customers so they
                        can shop with confidence and peace of mind.
                      </p>
                    </div>
                    <div className="store-sub-right">
                      <div className="store-edit-policy-grid">
                        <div className="store-edit-policy-group">
                          <div className="store-edit-policy-label">
                            <div className="store-edit-policy-label-text">
                              Return Policy
                            </div>
                            <button
                              className="store-edit-policy-edit-link"
                              type="button"
                              onClick={() =>
                                setFieldValue(
                                  "returnPolicyEditable",
                                  !values.returnPolicyEditable
                                )
                              }
                            >
                              {values.returnPolicyEditable ? (
                                "Done"
                              ) : (
                                <>
                                  <img
                                    className="edit-icon"
                                    src={EditIco}
                                    alt="edit"
                                  />{" "}
                                  Edit
                                </>
                              )}
                            </button>
                          </div>
                          <Field
                            as="textarea"
                            className={`store-edit-policy-content ${
                              errors.returnPolicy && touched.returnPolicy
                                ? "error"
                                : ""
                            }`}
                            name="returnPolicy"
                            readOnly={!values.returnPolicyEditable}
                          />
                          <ErrorMessage
                            name="returnPolicy"
                            component="div"
                            className="error-message"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Store Description */}
                <div className="store-edit-section">
                  <div className="inline-section">
                    <div className="store-sub-left">
                      <h3 className="store-edit-section-title">
                        Store description
                      </h3>
                      <p className="store-edit-section-subtitle">
                        Explain your store's return policy to customers so they
                        can shop with confidence and peace of mind
                      </p>
                    </div>

                    <div className="store-sub-right">
                      <div className="store-edit-policy-grid">
                        <div className="store-edit-policy-group">
                          <div className="store-edit-policy-label">
                            <div className="store-edit-policy-label-text">
                              Description
                            </div>
                            <button
                              className="store-edit-policy-edit-link"
                              type="button"
                              onClick={() =>
                                setFieldValue(
                                  "DescriptionEditable",
                                  !values.DescriptionEditable
                                )
                              }
                            >
                              {values.DescriptionEditable ? (
                                "Done"
                              ) : (
                                <>
                                  <img
                                    className="edit-icon"
                                    src={EditIco}
                                    alt="edit"
                                  />{" "}
                                  Edit
                                </>
                              )}
                            </button>
                          </div>

                          {/* Rich Text Editor */}
                          <div
                            className={`editor-container ${
                              errors.description && touched.description
                                ? "error"
                                : ""
                            }`}
                          >
                            <Editor
                              wrapperClassName="toolbar-wrapper-class"
                              editorClassName={`editor-main-class ${
                                !values.DescriptionEditable ? "read-only" : ""
                              }`}
                              editorState={editorState}
                              readOnly={!values.DescriptionEditable}
                              // toolbarHidden={!values.DescriptionEditable}
                              onEditorStateChange={(state: {
                                getCurrentContent: () => any;
                              }) => {
                                setEditorState(state);
                                setFieldValue(
                                  "description",
                                  draftToHtml(
                                    convertToRaw(state.getCurrentContent())
                                  )
                                );
                              }}
                              toolbar={{
                                options: [
                                  "inline",
                                  "blockType",
                                  "fontSize",
                                  "fontFamily",
                                  "list",
                                  "textAlign",
                                  "colorPicker",
                                  "history",
                                ],
                                inline: {
                                  inDropdown: false,
                                  options: [
                                    "bold",
                                    "italic",
                                    "underline",
                                    "strikethrough",
                                    "monospace",
                                  ],
                                },
                                blockType: {
                                  inDropdown: true,
                                  options: [
                                    "Normal",
                                    "H1",
                                    "H2",
                                    "H3",
                                    "H4",
                                    "H5",
                                    "H6",
                                    "Blockquote",
                                  ],
                                },
                                fontSize: {
                                  options: [
                                    8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36,
                                    48, 60, 72, 96,
                                  ],
                                },
                                fontFamily: {
                                  options: [
                                    "Arial",
                                    "Georgia",
                                    "Impact",
                                    "Tahoma",
                                    "Times New Roman",
                                    "Verdana",
                                  ],
                                },
                                colorPicker: {
                                  colors: [
                                    "rgb(97,189,109)",
                                    "rgb(26,188,156)",
                                    "rgb(84,172,210)",
                                    "rgb(44,130,201)",
                                    "rgb(147,101,184)",
                                    "rgb(71,85,119)",
                                    "rgb(204,204,204)",
                                    "rgb(65,168,95)",
                                    "rgb(0,168,133)",
                                    "rgb(61,142,185)",
                                    "rgb(41,105,176)",
                                    "rgb(85,57,130)",
                                    "rgb(40,50,78)",
                                    "rgb(0,0,0)",
                                    "rgb(247,218,100)",
                                    "rgb(251,160,38)",
                                    "rgb(235,107,86)",
                                    "rgb(226,80,65)",
                                    "rgb(163,143,132)",
                                    "rgb(239,239,239)",
                                    "rgb(255,255,255)",
                                    "rgb(250,197,28)",
                                    "rgb(243,121,52)",
                                    "rgb(209,72,65)",
                                    "rgb(184,49,47)",
                                    "rgb(124,112,107)",
                                    "rgb(209,213,216)",
                                  ],
                                },
                              }}
                            />
                          </div>

                          <ErrorMessage
                            name="description"
                            component="div"
                            className="error-message"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <Modal
                  show={showModal}
                  onHide={() => setShowModal(false)}
                  centered
                  className="store-edit-modal"
                >
                  <Modal.Header closeButton className="store-edit-modal-header">
                    <Modal.Title className="store-edit-modal-title">
                      {modalAction === "update" ? "Update Store" : "Reset Form"}
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body className="store-edit-modal-body">
                    {modalAction === "update"
                      ? "Are you sure you want to update the store details?"
                      : "This will clear all your changes. Continue?"}
                  </Modal.Body>
                  <Modal.Footer className="store-edit-modal-footer">
                    <Button
                      className="store-edit-modal-cancel-button"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      className={
                        modalAction === "update"
                          ? "store-edit-modal-update-button"
                          : "store-edit-modal-reset-button"
                      }
                      onClick={() => {
                        if (modalAction === "update") {
                          handleSubmit(values, { isSubmitting, resetForm }); // Formik's submit
                        } else if (modalAction === "reset") {
                          // Reset Formik values back to initial
                          resetForm({ values: { ...formikInitialValues } });
                          // Reset category multiselect
                          const catFormated = formikInitialValues.tags.map(
                            (each: any) => ({
                              label: each,
                              value: each,
                            })
                          );
                          SetTags(catFormated);
                          // Reset Google Places selected value to initial full address
                          setAddressSearched(
                            formikInitialValues.streetAddress
                              ? {
                                  label: buildFullAddress(formikInitialValues),
                                  value: { manual: true },
                                }
                              : null
                          );

                          setStoreLogo(null);
                          setStoreLogoNew(false);

                          const fileInput = document.getElementById(
                            "vendor-logo"
                          ) as HTMLInputElement;
                          if (fileInput) {
                            fileInput.value = "";
                          }
                        }
                        setShowModal(false);
                      }}
                    >
                      Yes
                    </Button>
                  </Modal.Footer>
                </Modal>

                <div className="store-edit-actions">
                  <Button
                    type="button"
                    className="store-edit-submit-button"
                    onClick={async () => {
                      await geocodeFreeTextIfNeeded(values, setFieldValue);
                      setModalAction("update");
                      setShowModal(true);
                    }}
                  >
                    Update Store
                  </Button>

                  <Button
                    type="button"
                    className="store-edit-reset-button"
                    onClick={() => {
                      setModalAction("reset");
                      setShowModal(true);
                    }}
                  >
                    Reset
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

const InAppContent = ({ pageProps }: any) => {
  const { storeId } = useParams();

  // const [storeLogo, setStoreLogo] = useState<any>();
  // const [storeLogo, setStoreLogo] = useState<{
  //   file: File;
  //   image: string;
  //   timestamp: number;
  // } | null>(null);
  // const [storeLogoNew, setStoreLogoNew] = useState(false);

  const [storeLogo, setStoreLogo] = useState<{
    file: File;
    image: string;
    timestamp: any;
  } | null>(null);
  const [storeLogoNew, setStoreLogoNew] = useState(false);

  // console.log("updateStoreRequest", pageProps.updateStoreRequest);

  useEffect(() => {
    getStoreDetails({
      pageProps,
      payload: `?Id=${storeId}`,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const EditDisplay = () => {
    const storeDetails =
      pageProps.getStoreDetailsRequest?.request_data?.response?.data || null;
    return (
      <div className="reports_wrap">
        <div className="report_head_wrap">
          <div
            className="report_head_left"
            onClick={() => history.push(`/app/stores/${storeId}/details`)}
          >
            <div className="report_heading">
              <img className="back_ico" src={BackIco} alt="" />{" "}
              <span className="main_head_txt">Edit store information</span>{" "}
            </div>
          </div>
        </div>

        <div className="store_edit_section">
          <div className="store-menus">
            <NavLink
              end
              className={({ isActive }) => (isActive ? "active-nav" : "")}
              to={`/app/stores/${storeId}/edit`}
            >
              Store Details
            </NavLink>

            <NavLink
              end
              className={({ isActive }) => (isActive ? "active-nav" : "")}
              to={`/app/stores/${storeId}/edit/staff`}
            >
              Staff Account
            </NavLink>
            <NavLink
              end
              className={({ isActive }) => (isActive ? "active-nav" : "")}
              to={`/app/stores/${storeId}/edit/withdrawal`}
            >
              Withdrawal Method
            </NavLink>
          </div>

          {pageProps.updateStoreRequest.request_status ===
          appConstants.UPDATE_STORE_PENDING ? (
            <LoadingItem />
          ) : (
            <StoreManagementForm
              StoreData={storeDetails}
              UpdateStore={updateStore}
              UploadImage={uploadImage}
              storeLogo={storeLogo}
              setStoreLogo={setStoreLogo}
              storeLogoNew={storeLogoNew}
              setStoreLogoNew={setStoreLogoNew}
              pageProps={pageProps}
            />
          )}

          {/* {pageProps.updateStoreRequest.request_status ===
            appConstants.UPDATE_STORE_SUCCESS && (
            <StoreManagementForm
              StoreData={storeDetails}
              UpdateStore={updateStore}
              pageProps={pageProps}
            />
          )} */}

          {/* {pageProps.updateStoreRequest.request_status ===
            appConstants.UPDATE_STORE_FAILURE && (
            <div className="all_graphs">
              <AlertMsg
                type="error"
                message={pageProps.updateStoreRequest?.request_data.error}
              />
            </div>
          )} */}
        </div>
      </div>
    );
  };

  return (
    <div className="inapp-content">
      <div className="page-content dashboard">
        {pageProps.getStoreDetailsRequest.request_status ===
          appConstants.GET_STORE_DETAILS_PENDING && <LoadingItem />}
        {pageProps.getStoreDetailsRequest.request_status ===
          appConstants.GET_STORE_DETAILS_SUCCESS && <EditDisplay />}
        {pageProps.getStoreDetailsRequest.request_status ===
          appConstants.GET_STORE_DETAILS_FAILURE && (
          <AlertMsg
            type="error"
            message={pageProps.getStoreDetailsRequest?.request_data.error}
          />
        )}
      </div>
    </div>
  );
};

const StoreEditManagement = (pageProps: any) => {
  return (
    <InAppTemplate
      pageHeadingTitle="Vendor Management"
      childComponent={<InAppContent pageProps={pageProps} />}
    />
  );
};

const mapDispatchToProps = {
  getStoreDetailsAction: appActions.GetStoreDetails,
  updateStoreAction: appActions.UpdateStore,
  uploadImageAction: appActions.UploadProductImage,
};

const mapStateToProps = (state: any) => ({
  getStoreDetailsRequest: state.allInAppReducers.getStoreDetailsReducer,
  updateStoreRequest: state.allInAppReducers.updateStoreReducer,
  updateProductImageReducer: state.allInAppReducers.updateProductImageReducer,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StoreEditManagement);
